import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { S3StaticDatumsEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const S3StaticDatumsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <S3StaticDatumsEditCard
          id={Number(id)}
          client={Clients.S3}
          table_name={Tables.S3_STATIC_DATA}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.S3}
          audit_table_name={Tables.S3_STATIC_DATA}
        />
      </div>
    </div>
  );
};
